import { Link } from 'gatsby';
import { useState, type FC } from 'react';
import logo from '../../images/logoNew.png';
import BurgerMenu from './burger-nav';
import { HeaderMenuProvider } from './header-menu-context';
import LayoutNav from './navigation';
import RequestQuoteButton from './request-quote-btn';
import TopBar from './top-bar';

type LayoutHeaderProps = {
  onOpenRequestForm: () => void;
};

const LayoutHeader: FC<LayoutHeaderProps> = ({ onOpenRequestForm }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <HeaderMenuProvider>
      <div className="site-header">
        <TopBar />
        <header className="site-header__main">
          <div className="site-header__container site-header__inner">
            <Link className="site-header__logo-link" to="/">
              <div className="site-header__logo-wrap">
                {!loaded ? <div className="site-header__logo-skeleton" /> : null}
                <img
                  alt="Sahil Machines"
                  className="site-header__logo-img"
                  height={76}
                  onLoad={() => {
                    setLoaded(true);
                  }}
                  src={logo}
                  style={{
                    position: loaded ? 'relative' : 'absolute',
                    visibility: loaded ? 'visible' : 'hidden',
                  }}
                  width={208}
                />
              </div>
            </Link>

            <LayoutNav />

            <RequestQuoteButton
              className="hidden shrink-0 lg:inline-flex"
              onClick={onOpenRequestForm}
            />

            <BurgerMenu onRequestQuote={onOpenRequestForm} />
          </div>
        </header>
      </div>
    </HeaderMenuProvider>
  );
};

export default LayoutHeader;
